import { Injectable } from "@angular/core";
import { CacheFactory, CacheStore, StorageMode, toBoolean } from "@obg/ngx.global";
import { forEach, head, map as lodashMap, unescape } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ContentClient } from "../content/content.client";
import { ContentConfigService } from "../content/content.config";
import { ContentCache, ContentDocument } from "../content/content.model";

import { ContentSection, ContentSectionResponse, ContentSectionState } from "./content-section.model";

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable({
	providedIn: "root",
})
export class ContentSectionService {
	private cache: CacheStore;

	constructor(
		private client: ContentClient,
		private config: ContentConfigService,
		cacheFactory: CacheFactory
	) {
		this.cache = cacheFactory.get(ContentCache.CacheStoreKey, {
			storageMode: StorageMode.Memory,
			maxAge: this.config.getContentSectionsCacheMaxAge(),
		});
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentValue.getContentSectionGroup) instead
	 */
	get(name: string): Observable<ContentSectionState> {
		return this.cache.getOrSetAsObservable(`${ContentCache.ContentSectionCacheKey}.${name}`, () =>
			this.client.getContentSections(name).pipe(
				map((response) => {
					const content: ContentSectionState = {};
					content[response.id] = {};
					forEach(response.documents, (rawContentSections, documentType) => {
						content[response.id][documentType] = lodashMap(
							rawContentSections,
							this.processRawContentSections
						);
					});
					return content;
				})
			)
		);
	}

	private processRawContentSections(rawContentSection: ContentDocument<ContentSectionResponse>): ContentSection {
		const content = rawContentSection.content;
		const metadata = content.metadata;

		const contentSection: ContentSection = {
			documentKey: rawContentSection.documentKey,
			title: {
				text: unescape(head(content.title)),
			},
			body: {
				text: unescape(head(content.body)),
			},
			image: head(content.image),
			ctaUrl: head(content.ctaUrl),
			ctaLabel: head(content.ctaLabel),
			link: head(content.link),
			linkText: head(content.linkText),
			allImages: content.image,
		};

		if (metadata) {
			contentSection.fragmentIdentifier = unescape(head(metadata.fragmentIdentifier));
			contentSection.alternateStyling = toBoolean(head(metadata.alternateStyling));
		}

		return contentSection;
	}
}
